import './persons_information_groups';
import './persons_information_groups-list';
import './persons_information_groups-edit'; 